import { CustomerActiveSubscriptionState } from 'services/api/customer/types';

export const isSubscriptionWithAutoRenewal = (subscriptionState: CustomerActiveSubscriptionState) =>
  subscriptionState.status === 'subscribed';
